var $5582a397c204a97c$exports = {};
$5582a397c204a97c$exports = {
    "loading": `Nalaganje ...`,
    "loadingMore": `Nalaganje ve\u{10D} vsebine ...`
};


export {$5582a397c204a97c$exports as default};
//# sourceMappingURL=sl-SI.module.js.map
